export const INCREMENT_POST_LIKE_COUNT_REQUEST = 'post/INCREMENT_LIKE_COUNT_REQUEST';
export const INCREMENT_POST_LIKE_COUNT_SUCCESS = 'post/INCREMENT_LIKE_COUNT_SUCCESS';
export const INCREMENT_POST_LIKE_COUNT_FAILURE = 'post/INCREMENT_LIKE_COUNT_FAILURE';

export const incrementPostLikeCountRequest = (postId) => ({
  type: INCREMENT_POST_LIKE_COUNT_REQUEST,
  payload: { _id: postId },
});

export const incrementPostLikeCountFailure = (postId) => ({
  type: INCREMENT_POST_LIKE_COUNT_FAILURE,
  payload: { _id: postId },
});

export const incrementPostLikeCountSuccess = (postId, { count, isLiked }) => ({
  type: INCREMENT_POST_LIKE_COUNT_SUCCESS,
  payload: { _id: postId, likeCount: count, isLiked },
});

export function incrementPostLikeCount(postId, isLiked, likeCount) {
  return async (dispatch, _, { request, requestFromSocialBlog }) => {
    dispatch(incrementPostLikeCountRequest(postId));

    const settingsResponse = await requestFromSocialBlog('/_api/blog-settings-service/v2/blog-settings');

    if (settingsResponse.blogSettings.useBlogLikeService) {
      try {
        const result = (await isLiked)
          ? requestFromSocialBlog.delete(
              `/_api/blog-like-service/v1/likes/fqdn/wix.blog.v3.post/entity-id/${postId}?entityId=${postId}&fqdn=wix.blog.v3.post`,
            )
          : requestFromSocialBlog.post('/_api/blog-like-service/v1/likes', {
              like: { entityId: postId, fqdn: 'wix.blog.v3.post' },
            });

        dispatch(incrementPostLikeCountSuccess(postId, { _id: postId, likeCount, isLiked: !isLiked }));

        return result;
      } catch (error) {
        dispatch(incrementPostLikeCountFailure(postId));
      }
    } else {
      try {
        const result = await request.post(`/_api/posts/${postId}/likes`, {});

        dispatch(incrementPostLikeCountSuccess(postId, result));

        return result;
      } catch (error) {
        dispatch(incrementPostLikeCountFailure(postId));
      }
    }
  };
}
